var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQCount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.74973 6.50186C7.89656 6.08447 8.18637 5.7325 8.56784 5.50831C8.94931 5.28412 9.39781 5.20217 9.83391 5.27697C10.27 5.35177 10.6656 5.57851 10.9505 5.917C11.2355 6.2555 11.3914 6.68393 11.3908 7.1264C11.3908 8.37547 9.51716 9 9.51716 9M9.54131 11.5H9.54965M9.4164 15.6667C13.3284 15.6667 16.4997 12.4953 16.4997 8.58333C16.4997 4.67132 13.3284 1.5 9.4164 1.5C5.50438 1.5 2.33306 4.67132 2.33306 8.58333C2.33306 9.375 2.46293 10.1363 2.70254 10.8472C2.7927 11.1147 2.83779 11.2484 2.84592 11.3512C2.85395 11.4527 2.84788 11.5238 2.82277 11.6225C2.79735 11.7223 2.74122 11.8262 2.62897 12.034L1.26593 14.557C1.0715 14.9168 0.974286 15.0968 0.996043 15.2356C1.01499 15.3566 1.08618 15.4631 1.19071 15.5269C1.31071 15.6001 1.51414 15.579 1.92101 15.537L6.18853 15.0958C6.31777 15.0825 6.38238 15.0758 6.44128 15.0781C6.49921 15.0803 6.5401 15.0857 6.59659 15.0987C6.65402 15.112 6.72625 15.1398 6.87069 15.1954C7.66073 15.4998 8.51908 15.6667 9.4164 15.6667Z",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQCount);
export default __webpack_public_path__ + "static/media/qCount.0f1db04037b5147ec69dd72e7846e2d3.svg";
export { ForwardRef as ReactComponent };